import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, Outlet } from "react-router-dom";

// css
import styles from "./Auth.module.scss";

// img
import logo from "../../Assets/images/logo.png";

const AuthLayout = () => {
  return (
    <>
      <section
        className={`${styles.authLayout} authLayout position-relative py-3 d-flex align-items-center justify-content-center flex-column`}
        style={{ zIndex: "9", minHeight: "100vh" }}
      >
        <Col
          lg="5"
          className={`${styles.imgWrpper} ${styles.logo} position-fixed d-none d-lg-flex align-items-center justify-content-center h-100`}
        >
          <img src={logo} alt="" className="img-fluid" />
        </Col>
        <Container className="h-100">
          <Row className="justify-content-end h-100">
            <Col lg="7" className="my-2 h-100">
              <div
                className={`${styles.formWrpper} h-100 formWrpper py-5`}
                // style={{ background: "#FBFBFB" }}
              >
                {" "}
                <Outlet />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AuthLayout;
